export default __webpack_public_path__ + "static/media/delimeals.40d08662.png";